// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton--mp-_hIbM","bone":"bone--mp-P99dx"};